export const ACTIVE_DIRECTORY = Object.freeze({
  activeDirectorySettings: 'activeDirectorySettings',
  adfsTenant: 'adfs',
  promptParameter: 'promptParameter'
});
